import { DownSquareOutlined, EllipsisOutlined } from '@ant-design/icons';
import { Dropdown } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import type DocumentFolder from 'stores/DocumentFolder';

import { MenuButton } from './OptionsMenu.styles';

export interface OptionsMenuProps {
  documentId: string;
  parentDocument: DocumentFolder;
}

function OptionsMenu({ documentId, parentDocument }: OptionsMenuProps) {
  // The parent's permission, not the child's: the rules let an editor of a
  // folder write its children, and the children listed here are never
  // load()ed, so their own members aren't available (child.canEdit would
  // be false for everyone but superusers). Same check as AddDocumentButton.
  const isArchiveEnabled = parentDocument.canEdit;

  const onArchiveClick = () => {
    parentDocument.documents.getById(documentId)?.archive();
  };

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
    >
      <Dropdown
        trigger={['click']}
        menu={{
          items: [
            {
              icon: <DownSquareOutlined />,
              key: 'Archive',
              label: 'Archive',
              title: 'Archive',
              disabled: !isArchiveEnabled,
              onClick: onArchiveClick,
            },
          ],
        }}
      >
        <MenuButton>
          <EllipsisOutlined />
        </MenuButton>
      </Dropdown>
    </div>
  );
}

export default observer(OptionsMenu);
